import * as React from "react";
import { reducer, initState } from "../../../reducers/job/detail";
import { JobDetailPage } from "../../../components/pages/job/detail";
import { ConfirmBox } from "../../../components/parts/confirm-box";
import { Loading } from "../../../../../react-components/lu-component/src/index";
import { useNavigate, useParams } from "react-router-dom";
import { get, makeError } from "../../../lib/request";
import { endpoint } from "../../../../../server/router/endpoint";
import { GetJobDetailResponse } from "../../../../../server/types/request/job-detail";

export const JobDetailContainer = () => {
	const [state, dispatch] = React.useReducer(reducer, initState);
	const { loading, info, ...jobDetailProps } = state;
	const navigate = useNavigate();
	const { jobId, activityId } = useParams<{ jobId: string; activityId: string }>();
	React.useEffect(() => {
		get<GetJobDetailResponse>(`${endpoint.jobDetail}/${jobId}`)
			.then((response) => {
				dispatch({ type: "loadJob", payload: response.data });
			})
			.catch((error) => {
				dispatch({ type: "changeMessageInfo", payload: makeError(error) });
			});
	}, [jobId]);
	const onJobList = React.useCallback(() => navigate(`/activity/${activityId}/job`), [activityId, navigate]);
	return (
		<>
			<Loading loading={loading} />
			<ConfirmBox info={info} onClose={onJobList} />
			{!!jobDetailProps.activity && <JobDetailPage {...jobDetailProps} onJobList={onJobList} />}
		</>
	);
};
